import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

export default {
    install: (app, options) => {
        if (!options) {
            throw new Error('[Vue-Echo] cannot locate options');
        }

        if (typeof options !== 'object') {
            throw new Error('[Vue-Echo] cannot initiate options');
        }

        if (typeof options.socketId === 'function') {
            app.config.globalProperties.$echo = options;
        } else {
            app.config.globalProperties.$echo = new Echo(options);
        }
    },
};
